import type {UserPermissionType} from '@ambler/prisma'
import {isStaffEmail} from '@ambler/shared'
import {useAuth} from '../components/stack/auth'

const useHasPermission = (type: UserPermissionType) => {
  const {permissions = [], isLoading} = useAuth()
  return !isLoading && permissions?.some(p => p.type === type)
}

export const useCanManageBoUsers = () => {
  const canManage = useHasPermission('BO_MANAGE_USERS')
  return process.env.AMBLER_STAGE?.startsWith('local') || canManage
}

export const useCanExportAnon = () => {
  const canExportAnon = useHasPermission('BO_EXPORT_ANONYMOUS')
  return canExportAnon
}

export const useCanExportFull = () => {
  const canExportFull = useHasPermission('BO_EXPORT_FULL')
  return canExportFull
}

export const useCanReadPatientIdentity = () => {
  const {user, isLoading} = useAuth()
  const canViewPatientIdentity = useHasPermission('BO_PATIENT_IDENTITY_READ')

  // Fail closed until the identity is known. The email can be missing for three
  // reasons — still loading, query failed, query skipped — and the staff test
  // below reads an absent email as "not staff", which grants access. Anything
  // negating a staff check has to gate on the identity being known first.
  if (isLoading || !user.email) {
    return false
  }

  return canViewPatientIdentity || !isStaffEmail(user.email)
}
